// extracted by mini-css-extract-plugin
module.exports = {"icon-box":"icon-box__2NdvY","active":"active__2cefR","title":"title__2PJcL","form":"form__3jay7","modal":"modal__3_4xv"};